<script setup>
import {inject, provide} from "vue";

const props = defineProps({
    step: {
        type: Object,
        required: true,
    }
});

const wizard = inject('wizard');

function canGoBack() {
    return wizard.canGoBack();
}

function goNext(eventData = undefined) {
    return wizard.goNext(eventData);
}

function goBack() {
    return wizard.goBack();
}
</script>

<template>
    <template v-if="wizard.currentStep.value.name === step.name">
        <slot :stepName="step.name" :stepIndex="step.index" :canGoBack="canGoBack" :goNext="goNext" :goBack="goBack"></slot>
    </template>
</template>
